export default __webpack_public_path__ + "static/media/html-5.821ba738.svg";